export const Z_INDEX = {
  bgHighlights: '-z-10',
  // Should remain larger than `pagePopover`.
  navbar: 'z-40',
  dialogOverlay: 'z-50',
  // Should remain larger than `dialogOverlay`.
  dialogContainer: 'z-[51]',
  // Popovers/dropdowns render via portals and must be above dialogs.
  popover: 'z-[52]',
} as const;
